/**
 * Класс содержит вспомогательные функции для разных компонентов
 */
export class Element {

  /**
   * Генерирует случайный идентификатор для элемента
   */
  public static generateId(): string {
    const salt = Math.random().toString(36).substring(2, 11);
    return 'form_element_' + salt;
  }

  /**
   * Получение позиции элемента по оси X
   * @param obj
   */
  public static findPosX(obj: any) {
    let curleft = 0;
    if (obj.offsetParent) {
      while (1) {
        curleft += obj.offsetLeft;
        if (!obj.offsetParent) {
          break;
        }
        obj = (obj.offsetParent);
      }
    } else if (obj.x) {
      curleft += obj.x;
    }
    return curleft;
  }

  /**
   * Получение позиции элемента по оси Y
   * @param obj
   */
  public static findPosY(obj: any) {
    let curtop = 0;
    if (obj.offsetParent) {
      while (1) {
        curtop += obj.offsetTop;
        if (!obj.offsetParent) {
          break;
        }
        obj = obj.offsetParent;
      }
    } else if (obj.y) {
      curtop += obj.y;
    }
    return curtop;
  }

  /**
   * Возвращает значение в пикселях на сколько прокручена текущая страница по оси Y
   */
  public static getBodyScrollTop(): number {
    if (document.documentElement && document.documentElement.scrollTop) {
      return document.documentElement.scrollTop;
    } else if (document.body && document.body.scrollTop) {
      return document.body.scrollTop;
    } else {
      return 0;
    }
  }

  /**
   * Возвращает значение в пикселях на сколько прокручена текущая страница по оси X
   */
  public static getBodyScrollLeft(): number {
    if (document.documentElement && document.documentElement.scrollLeft) {
      return document.documentElement.scrollLeft;
    } else if (document.body && document.body.scrollLeft) {
      return document.body.scrollLeft;
    } else {
      return 0;
    }
  }

  /**
   * Получение абсолютной позиции элемента по оси X
   * @param obj
   */
  public static findAbsPosX(obj: any) {
    return Element.findPosX(obj) - Element.getBodyScrollTop();
  }

  /**
   * Получение абсолютной позиции элемента по оси Y
   * @param obj
   */
  public static findAbsPosY(obj: any) {
    return Element.findPosY(obj) - Element.getBodyScrollLeft();
  }
}
